module.exports = __webpack_public_path__ + "static/img/william-iven-SpVHcbuKi6E-unsplash_thumb.d7cbc25.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/william-iven-SpVHcbuKi6E-unsplash_thumb.png
// module id = yMg4
// module chunks = 4